import React, {useEffect, useState} from 'react';
import { Container, Title, ContainerChild, ContainerLeft, ContainerRight, AlarmIndicator } from './styles'
// import CriticoIcon from '../CriticoIcon';
// import AdvertenciaIcon from '../AdvertenciaIcon';
// import NonAlarm from '../NonAlarm';
import { CriticoIcon, AdvertenciaIcon, NonAlarm } from '../../Components';

/**
 * Componente para o Card
 * @returns {ReactComponentElement} 
 */
const Card = ({id, Name, RightSide, LeftSide, changeGraph, active, invisible, ShowAlarms, Alarms, valor, Comunication}) => {
    const [isAlarm, setIsAlarm] = useState(false);

    useEffect(() => {
        if(Alarms?.alarmHH && Alarms?.alarmH && Alarms?.alarmL && Alarms?.alarmLL){
            setIsAlarm('all')
        }else if(Alarms?.alarmHH && Alarms?.alarmH){
            setIsAlarm('h')
        }else if(Alarms?.alarmLL && Alarms?.alarmL){
            setIsAlarm('l')
        }
    }, [Alarms])
    
    // Função para exibir os alarmes vinculados ao item, caso haja alarmes
    const openAlarms= () => {
        if(isAlarm === 'all'){
            ShowAlarms(Name ,Alarms.alarmL.variavel, Alarms.alarmLL.variavel, Alarms.alarmH.variavel, Alarms.alarmHH.variavel)
        }else if(isAlarm === 'h'){
            ShowAlarms(Name, null, null, Alarms.alarmH.variavel, Alarms.alarmHH.variavel)
        }else if (isAlarm === 'l'){
            ShowAlarms(Name, Alarms.alarmL.variavel, Alarms.alarmLL.variavel, null, null)
        }
    }

    // Função para buscar o nivel de alerta
    const getAlarm = (valor, l, ll, h, hh, Comunicacao) => {
        if(Comunicacao === 3){
            return '#60C';
        }else if(Comunicacao === 4){
            return '#E1800E';
        }
        if(ll != null && (hh === null || hh === undefined) && ll === l){
            return '#00375E'
        }
        if(hh != null && (ll === null || ll === undefined) && hh === h){
            return '#00375E'
        }
        if(hh === h && ll === l && hh === ll){
            return '#00375E'
        }
        if(ll != null &&  ll !== 0){
            if (parseFloat(valor) <= parseFloat(ll)){
                return '#FF3939';
            }
        }
        if(hh != null && hh !== 0){
            if (parseFloat(valor) >= parseFloat(hh)){
                return '#FF3939';
            }
        }
        if(l != null &&  l !== 0){
            if (parseFloat(valor) <= parseFloat(l)){
                return '#EABC1A';
            }
        }
        if(h != null && h !== 0){
            if (parseFloat(valor) >= parseFloat(h)){
                return '#EABC1A';
            }
        }
        return '#3C9';
    }

    let color = getAlarm(valor, Alarms?.alarmL?.variavel?.valor, Alarms?.alarmLL?.variavel?.valor, Alarms?.alarmH?.variavel?.valor, Alarms?.alarmHH?.variavel?.valor, Comunication)

    return (
        <Container id={id} $invisible={invisible} $active={active} color={color} 
            onClick={()=>changeGraph(color)}
            onDoubleClick={()=>openAlarms()}>
            <Title $active={active}> {Name} </Title>
            <AlarmIndicator>
                {active ?
                    color === '#FF3939' ? <CriticoIcon width={'15'} height={'15'}/> : 
                    color === '#EABC1A' ? <AdvertenciaIcon width={'15'} height={'15'}/> : 
                    color === '#00375E' ? <NonAlarm width={'15'} height={'15'}/> :
                    null :
                    color === '#FF3939' ? <CriticoIcon width={'15'} height={'15'} fill={'#fff'}/> : 
                    color === '#EABC1A' ? <AdvertenciaIcon width={'15'} height={'15'} fill={'#fff'}/> : 
                    color === '#00375E' ? <NonAlarm width={'15'} height={'15'} fill={'#fff'}/> :
                    null
                }
            </AlarmIndicator>
            <ContainerChild>
                <ContainerLeft>
                    {LeftSide}
                </ContainerLeft>
                <ContainerRight>
                    {RightSide}
                </ContainerRight>
            </ContainerChild>
        </Container>
    );
}

export default Card;
